import { useMemo } from 'react';
import { useSelectedScopes } from '@/hooks/use-selected-scopes';
import { useAuthStore } from '@/stores/auth-store';

/** Personal pages only cover configurations where the user is also a socio. */
export function useMemberScopes() {
	const { scopes, loading } = useSelectedScopes();
	const loaded = useAuthStore((s) => s.loaded);
	const memberTenantIds = useAuthStore((s) => s.memberTenantIds);
	const memberScopes = useMemo(
		() => scopes.filter((scope) => memberTenantIds.includes(scope.tenantId)),
		[scopes, memberTenantIds],
	);
	return { scopes: memberScopes, isMulti: memberScopes.length > 1, loading: !loaded || loading };
}
